/*
 * @Author: 李智 13097090+li-zhi-xuan@user.noreply.gitee.com
 * @Date: 2023-07-28 08:34:44
 * @LastEditors: 李智 13097090+li-zhi-xuan@user.noreply.gitee.com
 * @LastEditTime: 2023-08-04 13:57:46
 * @FilePath: \youmo-official-website\src\utils\request.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
//引入axios
import axios from "axios";
// 发送ajax的服务器地址
// axios.defaults.baseURL = 'http://172.16.20.100:92/api'
// axios.defaults.baseURL = 'http://118.24.89.187/api'
axios.defaults.baseURL = 'https://gw-api.scyoumo.com/api'
// axios.defaults.baseURL = 'http://172.16.20.100:92/api'
import {
    Message
} from 'element-ui'


// 请求超时时间，如果请求时间超过10秒，就报错。
axios.defaults.timeout = 10000

//请求拦截器
axios.interceptors.request.use((config) => {

    return config;
}, (err) => {
    return Promise.reject(err)
})

//响应拦截器
axios.interceptors.response.use((response) => {
    // console.log('config', config)

    //判断 如果有code 和msg 字段
    // let { code, msg } = response.data;
    // if (code === 0) {
    //     Message: ({
    //         message: msg,
    //         type: "success"
    //     });
    // }
    // if (code === 1) {
    //     Message.error(msg)
    // }
    return response;

    // 把请求拦截下来 统一携带参数
}, (err) => {

    Message({
        message: err.response.data && err.response.data.message || '服务器响应失败!!请联系管理员',
        type: 'error',
        duration: 5 * 1000
    })
    // err.name = "zhaohuaiqiang"
    return Promise.reject(err)
})

//暴露出去
export default axios